<template>
  <div class="vg-confirmation-hero">
    <h1 v-if="title" class="vg-confirmation-hero__title confirmation-title">
      {{ title }}
    </h1>
    <h1 v-if="retryTitle" class="vg-confirmation-hero__title">
      <span class="confirmation-title1 text-danger">{{ retryTitle }}</span>
    </h1>
    <p v-if="subtitle" class="vg-confirmation-hero__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "ConfirmationTitle",
  computed: {
    title() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;

      if (!retryOrderId) {
        if (window?.globalConfig?.confirmationLabel) {
          return window.globalConfig.confirmationLabel;
        }
        if (window?.globalConfig?.isOrderPage) {
          return this.$t("messages.orderConfirmation");
        }
        return this.$t("messages.thanksForYourOrder");
      }
      return null;
    },
    retryTitle() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;

      if (retryOrderId) {
        return this.$t("messages.retryCrossell1");
      }
      return null;
    },
    subtitle() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;

      if (retryOrderId) {
        return this.$t("messages.retryCrossell2");
      } else {
        return this.$t("messages.confirmationEmailSent");
      }
    },
  },
  methods: {},
};
</script>
